// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"580":"b696c087886a2f04","786":"2275502f1e900e5a","940":"e20592ded383f573"}[chunkId] + ".js";
};